evaluationDiv = document.getElementById('evaluationDiv');
resultsDiv = document.getElementById('resultsDiv');
endscreenDiv = document.getElementById('endscreen');

function evaluateInput() {
    console.log('evaluating user input');
    userInput = textField.value;

      
    if (userInput.length * 10 < texts.length) {
        
        msg = "Bitte schreibe das vollständige Diktat auf."
        evaluateButton.innerHTML = msg;
        setTimeout(() => {
            evaluateButton.innerHTML = 'Auswerten';
        }, 2000);
        return
    }
    

    compareTexts(userInput, texts);
    addEndscreen();
    evaluateButton.style.display = 'none';
}

function compareTexts(userInput, texts) {

    console.log('comparing texts', userInput, texts);
    userInputPhrases = splitTextToPhrases(userInput);
    expectedPhrases = splitTextToPhrases(texts);
    gameDiv.style.display = 'none';
    renderTexts(userInputPhrases, expectedPhrases);
}

function renderTexts(userInputPhrases, expectedPhrases) {
    i = 0

    mistakes = 0    

    for (i = 0; i < expectedPhrases.length; i++) {
        sentenceParagraph = document.createElement('p');  
        try {
            inputWords = userInputPhrases[i].split(' ');
        } catch (error) {
            continue;            
        }
        expectedWords = expectedPhrases[i].split(' ');



        sentenceHeadline = document.createElement('h4');
        
        if (expectedPhrases[i] == userInputPhrases[i]) {
            sentenceHeadline.innerText = `Satz ${i+1} - Korrekt!`;
        } else {
            sentenceHeadline.innerText = `Satz ${i+1} - Falsch!`;
        }
        evaluationDiv.appendChild(sentenceHeadline);

        if (expectedPhrases[i] == userInputPhrases[i]) {
            console.log('wrong word found!')
            correctSentencesParagraph = document.createElement('p');
            correctSentencesParagraph.innerHTML = `<p class="correct">${expectedPhrases[i]}</p>`;
            evaluationDiv.appendChild(correctSentencesParagraph);
            continue
        }

        if (expectedPhrases[i] !== userInputPhrases[i]) {
            console.log('wrong word found!')
            correctSentencesParagraph = document.createElement('p');
            correctSentencesParagraph.innerText = `Korrekt wäre gewesen: ${expectedPhrases[i]}`;
            evaluationDiv.appendChild(correctSentencesParagraph);
        }


        if (inputWords.length < expectedWords.length) {
            incompleteSentcence = document.createElement('span');
            incompleteSentcence.innerText = `Deine Eingabe: ${userInputPhrases[i]} (Hier fehlen bei deiner Eingabe wesentliche Teile.)`;
            incompleteSentcence.className = 'wrong';
            sentenceParagraph.appendChild(incompleteSentcence);
            mistakes++;
            evaluationDiv.appendChild(sentenceParagraph);
            continue;
        }

        if (inputWords.length > expectedWords.length) {
            incompleteSentcence = document.createElement('span');
            incompleteSentcence.innerText = `Deine Eingabe: ${userInputPhrases[i]} (Hier hast du etwas ergänzt, was hier nicht hingehört.)`;
            incompleteSentcence.className = 'wrong';
            sentenceParagraph.appendChild(incompleteSentcence);
            mistakes++;
            evaluationDiv.appendChild(sentenceParagraph);
            continue;
        }

        for (j = 0; j < inputWords.length; j++) {
            wordSpan = document.createElement('span');
            
            if (j == 0) {
                wordSpan.innerText = 'Deine Eingabe: ', inputWords[j] + ' ';
            } else {
                wordSpan.innerText = inputWords[j] + ' ';
            }
            
            if (inputWords[j] !== expectedWords[j]) {
                wordSpan.className = 'wrong';
                mistakes++;
            }

            sentenceParagraph.appendChild(wordSpan);
        }

        evaluationDiv.appendChild(sentenceParagraph);
    }

    

    resultsDiv.innerHTML = 
        `<h3>Du hast ${mistakes} Fehler gemacht.</h3>`;
}




function splitTextToPhrases(text) {
    const sentencePattern = /(?<=[.!?])\s+/;
    const phrases = text.split(sentencePattern);
    phrases.forEach((phrase) => {
    console.log(phrase.trim());
    });

    console.log(phrases);
    return phrases

}

